import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { ReactComponent as Arrow } from 'assets/images/arrow-forw.svg';
import { ReactComponent as BaseCarIcon } from 'assets/images/autos/icon-car.svg';
import { ReactComponent as Group } from 'assets/images/group.svg';
import { ReactComponent as Guest } from 'assets/images/invite.svg';
import { ReactComponent as Money } from 'assets/images/money.svg';
import Button from 'components/Buttons/Button';
import ListItem from 'components/List/ListItem';

export const Item = styled(ListItem)`
  border-radius: 16px;
  margin-bottom: 20px;

  background: ${ColorPalette.HEX.White};
  box-shadow: 0 2px 12px 0 rgba(${ColorPalette.RGB.DeepTaupe2}, 0.16);

  cursor: pointer;

  @media ${({ theme }) => theme.device.desktop} {
    margin-bottom: 0;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  width: 100%;
  height: 100%;
  padding: 8px;
  border-radius: 16px;
`;

export const TravelInfo = styled.span`
  font-size: 12px;
  letter-spacing: 0.2px;
  color: ${ColorPalette.HEX.DimGray};
`;

export const ETicket = styled.span`
  font-size: 12px;
  line-height: 1.33;
  letter-spacing: 0.2px;
  color: ${ColorPalette.HEX.DimGray};
  margin-bottom: 32px;
`;

export const InfoContainer = styled.div``;

export const Info = styled.span`
  display: flex;
  font-size: 14px;
  color: ${ColorPalette.HEX.DimGray};
  padding: 4px 0 0 32px;
`;

export const Title = styled.div`
  font-size: 16px;
  line-height: 1.2em;
  font-weight: 600;
  color: ${ColorPalette.HEX.CharlestonGreen};
  display: flex;
`;

export const Icon = styled.img`
  height: 14px;
  padding-right: 14px;
`;

export const SubTitle = styled.div`
  display: flex;
  flex-direction: row;
  height: 16px;
  font-size: 12px;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: 0.2px;
  margin-top: 20px;
  color: ${ColorPalette.HEX.DimGray};
`;

export const ReportLabel = styled.div`
  margin-left: auto;
  color: ${ColorPalette.HEX.DimGray};
`;

export const Separator = styled.div`
  width: 100%;
  height: 1px;
  opacity: 0.3;
  border-bottom: solid 1px ${ColorPalette.HEX.DimGray};
  margin-top: 10px;
  margin-bottom: 8px;
`;

export const Expenses: any = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

Expenses.Value = styled.span`
  height: 24px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.5;
  color: ${ColorPalette.HEX.CharlestonGreen};
`;

Expenses.Count = styled.span`
  height: 16px;
  font-size: 12px;
  line-height: 1.33;
  letter-spacing: 0.2px;
  margin-left: auto;
  color: ${ColorPalette.HEX.DimGray};
`;

export const TravelCardHeader = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 24px;
`;

export const UserLabel = styled.span`
  display: inline-flex;
  align-items: center;
  align-self: flex-end;
  font-size: 14px;
  color: ${ColorPalette.HEX.Manatee};

  margin-left: 8px;
`;

export const GroupIcon = styled(Group)`
  margin-right: 4px;
`;

export const GuestIcon = styled(Guest)`
  margin-right: 4px;
`;

export const CarIcon = styled(BaseCarIcon)`
  margin-right: 14px;
  width: 18px;
  height: 16px;
  vertical-align: top;
`;

export const MoneyIcon = styled(Money)`
  width: 18px;
  margin-right: 9px;
`;

export const ArrowIcon = styled(Arrow)`
  width: 16px;
  height: 16px;
  margin: 0 5px;
  vertical-align: middle;
`;

export const TravelDestination = styled.div``;

export const AcceptButton = styled(Button)``;

type TravelImageProps = {
  $image: string;
};

export const TravelImage = styled.div<TravelImageProps>`
  width: 100%;
  height: 181px;
  border-radius: 8px;
  margin-bottom: 12px;
  background-position: center;
  background-size: cover;
  background-image: ${({ $image }) => `url(${$image}), url(https://images.rappi.com/web/travel/heros/hero-flight.svg)`};
`;
